import { httpsCallable } from "firebase/functions";

import { firebaseFunctions } from "./firebase";

export const helloWorld = httpsCallable<undefined, { message: string }>(firebaseFunctions, "helloWorld");
export const ping = httpsCallable<{ message: string }, { message: string }>(firebaseFunctions, "ping");
export const blockTrackById = httpsCallable<{ trackId: string }>(firebaseFunctions, "blockTrackById");
